import axios from 'axios'

import {
  ADD_ROLE_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  GET_ROLES_FAIL,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLE_BY_ID_FAIL,
  GET_ROLE_BY_ID_REQUEST,
  GET_ROLE_BY_ID_SUCCESS,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
} from '../constants/roleConstants'
import { logout } from './userActions'

const baseUrl = process.env.REACT_APP_API_URL;

export const getRoles = (search = '') => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ROLES_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/roles${search ? `?search=${encodeURIComponent(search)}` : ''}`, config)

    dispatch({
      type: GET_ROLES_SUCCESS,
      payload: data,
    })
  } catch (error) {
    // if (error.response.status === 401) {
    //   dispatch(logout())
    //   return
    // }
    dispatch({
      type: GET_ROLES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const addRole = (
  name,

  usersView,
  usersAdd,
  usersUpdate,
  usersBulkSelect,
  rejoinUsers,
  forceLogoutUsers,
  resetUserRateLimit,

  resignedUsers,
  rolesView,
  rolesAdd,
  rolesUpdate,
  rolesDelete,
  auditLogView,

  appAccess,
  webAccess,
  settings,
  reports,

  dashboard,

  loanEnquiriesView,
  loanEnquiriesEdit,
  loanEnquiriesDelete,
  loanEnquiriesSendBack,
  loanEnquiriesTransferMerchant,
  paymentView,
  sendBackEnquiriesView,
  sendBackEnquiriesEdit,
  sendBackEnquiriesDelete,
  sendBackEnquiriesRestore,
  sendBackEnquiriesWelcomeCall,
  merchantPageView,
  merchantView,
  merchantAdd,
  merchantEdit,
  merchantDelete,
  merchantToggle,
  productMasterView,
  productMasterAdd,
  productMasterUpdate,
  productMasterDelete,
  qrView,
  formView,
  // ADD THESE PARAMETERS
  qrPoolView,
  qrPoolCreate,
  qrPoolUpdate,
  qrPoolDelete,

  // Caller List
  callerListView,
  callerListAdd,
  callerListEdit,
  callerListDelete,
  // Prospects
  prospectsView,
  // Daily Call Report
  dailyCallReportView,
  dailyCallReportAdd,
  dailyCallReportEdit,
  dailyCallReportDelete,

  // Agent Program
  agentProgramView,
  agentProgramViewAll,
  agentProgramLeadSubmit,
  agentProgramMarkGenuine,
  agentProgramMarkAccepted,
  agentProgramMarkDisbursed,
  agentProgramMarkCommissionReceived,
  agentProgramClawback,
  agentProgramConfigView,
  agentProgramConfigEdit,
  agentProgramKycView,
  agentProgramKycVerify,
  agentProgramPayoutRelease,
  agentProgramRequestPayout,
  agentProgramReset
) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADD_ROLE_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/roles`,
      {
        name,

        usersView,
        usersAdd,
        usersUpdate,
        usersBulkSelect,

        rejoinUsers,
        forceLogoutUsers,
        resetUserRateLimit,

        resignedUsers,
        rolesView,
        rolesAdd,
        rolesUpdate,
        rolesDelete,
        auditLogView,

        appAccess,
        webAccess,
        settings,
        reports,

        dashboard,

        loanEnquiriesView,
        loanEnquiriesEdit,
        loanEnquiriesDelete,
        loanEnquiriesSendBack,
        loanEnquiriesTransferMerchant,
        paymentView,
        sendBackEnquiriesView,
        sendBackEnquiriesEdit,
        sendBackEnquiriesDelete,
        sendBackEnquiriesRestore,
        sendBackEnquiriesWelcomeCall,
        merchantPageView,
        merchantView,
        merchantAdd,
        merchantEdit,
        merchantDelete,
        merchantToggle,
        productMasterView,
        productMasterAdd,
        productMasterUpdate,
        productMasterDelete,
        qrView,
        formView,
        // ADD THESE TO THE REQUEST BODY
        qrPoolView,
        qrPoolCreate,
        qrPoolUpdate,
        qrPoolDelete,

        // Caller List
        callerListView,
        callerListAdd,
        callerListEdit,
        callerListDelete,
        // Prospects
        prospectsView,
        // Daily Call Report
        dailyCallReportView,
        dailyCallReportAdd,
        dailyCallReportEdit,
        dailyCallReportDelete,

        // Agent Program
        agentProgramView,
        agentProgramViewAll,
        agentProgramLeadSubmit,
        agentProgramMarkGenuine,
        agentProgramMarkAccepted,
        agentProgramMarkDisbursed,
        agentProgramMarkCommissionReceived,
        agentProgramClawback,
        agentProgramConfigView,
        agentProgramConfigEdit,
        agentProgramKycView,
        agentProgramKycVerify,
        agentProgramPayoutRelease,
        agentProgramRequestPayout,
        agentProgramReset,
      },

      config
    )

    dispatch({
      type: ADD_ROLE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ADD_ROLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
export const getRoleByID = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ROLE_BY_ID_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/roles/${id}`, config)

    dispatch({
      type: GET_ROLE_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    if (error.response.status === 401) {
      dispatch(logout())
      return
    }
    dispatch({
      type: GET_ROLE_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateRole =
  (
    id,
    name,

    usersView,
    usersAdd,
    usersUpdate,
    usersBulkSelect,

    rejoinUsers,
    forceLogoutUsers,
    resetUserRateLimit,

    resignedUsers,
    rolesView,
    rolesAdd,
    rolesUpdate,
    rolesDelete,
    auditLogView,

    appAccess,
    webAccess,
    settings,
    reports,

    dashboard,

    // Merchant permissions
    loanEnquiriesView,
    loanEnquiriesEdit,
    loanEnquiriesDelete,
    loanEnquiriesSendBack,
    loanEnquiriesTransferMerchant,
    paymentView,
    sendBackEnquiriesView,
    sendBackEnquiriesEdit,
    sendBackEnquiriesDelete,
    sendBackEnquiriesRestore,
    sendBackEnquiriesWelcomeCall,
    merchantPageView,
    merchantView,
    merchantAdd,
    merchantEdit,
    merchantDelete,
    merchantToggle,
    productMasterView,
    productMasterAdd,
    productMasterUpdate,
    productMasterDelete,
    qrView,
    formView,
    // QR Pool
    qrPoolView,
    qrPoolCreate,
    qrPoolUpdate,
    qrPoolDelete,

    // Caller List
    callerListView,
    callerListAdd,
    callerListEdit,
    callerListDelete,
    // Prospects
    prospectsView,
    // Daily Call Report
    dailyCallReportView,
    dailyCallReportAdd,
    dailyCallReportEdit,
    dailyCallReportDelete,

    // Agent Program
    agentProgramView,
    agentProgramViewAll,
    agentProgramLeadSubmit,
    agentProgramMarkGenuine,
    agentProgramMarkAccepted,
    agentProgramMarkDisbursed,
    agentProgramMarkCommissionReceived,
    agentProgramClawback,
    agentProgramConfigView,
    agentProgramConfigEdit,
    agentProgramKycView,
    agentProgramKycVerify,
    agentProgramPayoutRelease,
    agentProgramRequestPayout,
    agentProgramReset

  ) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: UPDATE_ROLE_REQUEST,
        })

        const {
          userLogin: { userInfo },
        } = getState()

        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.put(
          `${baseUrl}/roles/${id}`,
          {
            name,

            usersView,
            usersAdd,
            usersUpdate,
            usersBulkSelect,

            rejoinUsers,
            forceLogoutUsers,
            resetUserRateLimit,

            resignedUsers,
            rolesView,
            rolesAdd,
            rolesUpdate,
            rolesDelete,
            auditLogView,

            appAccess,
            webAccess,
            settings,
            reports,

            dashboard,

            // Merchant permissions
            loanEnquiriesView,
            loanEnquiriesEdit,
            loanEnquiriesDelete,
            loanEnquiriesSendBack,
            loanEnquiriesTransferMerchant,
            paymentView,
            sendBackEnquiriesView,
            sendBackEnquiriesEdit,
            sendBackEnquiriesDelete,
            sendBackEnquiriesRestore,
            sendBackEnquiriesWelcomeCall,
            merchantPageView,
            merchantView,
            merchantAdd,
            merchantEdit,
            merchantDelete,
            merchantToggle,
            productMasterView,
            productMasterAdd,
            productMasterUpdate,
            productMasterDelete,
            qrView,
            formView,
            // QR Pool
            qrPoolView,
            qrPoolCreate,
            qrPoolUpdate,
            qrPoolDelete,

            // Caller List
            callerListView,
            callerListAdd,
            callerListEdit,
            callerListDelete,
            // Prospects
            prospectsView,
            // Daily Call Report
            dailyCallReportView,
            dailyCallReportAdd,
            dailyCallReportEdit,
            dailyCallReportDelete,

            // Agent Program
            agentProgramView,
            agentProgramViewAll,
            agentProgramLeadSubmit,
            agentProgramMarkGenuine,
            agentProgramMarkAccepted,
            agentProgramMarkDisbursed,
            agentProgramMarkCommissionReceived,
            agentProgramClawback,
            agentProgramConfigView,
            agentProgramConfigEdit,
            agentProgramKycView,
            agentProgramKycVerify,
            agentProgramPayoutRelease,
            agentProgramRequestPayout,
            agentProgramReset
          },
          config
        )

        dispatch({
          type: UPDATE_ROLE_SUCCESS,
          payload: data,
        })
        return data
      } catch (error) {
        if (error.response?.status === 401) {
          dispatch(logout())
          throw error
        }
        dispatch({
          type: UPDATE_ROLE_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        })
        throw error
      }
    }
